interface MastercardSvgProps {
	className?: string;
}

/** Simplified Mastercard mark — the familiar overlapping-circles silhouette. */
function MastercardSvg(prop: MastercardSvgProps) {
	const { className } = prop;
	return (
		<svg viewBox="0 0 38 24" className={className} aria-label="Mastercard" role="img">
			<circle cx="15" cy="12" r="11" fill="#eb001b" />
			<circle cx="23" cy="12" r="11" fill="#f79e1b" />
			<path d="M19 3.6a11 11 0 0 1 0 16.8 11 11 0 0 1 0-16.8Z" fill="#ff5f00" />
		</svg>
	);
}

export default MastercardSvg;
